import { Chip, theme, Typography } from "kosmos-ui";
import DiscountTicket from "kosmos-ui/lib/icons/DiscountTicket";

import { formatDate, formatNumber } from "app/helpers/general";
import { ORDER_STATUS_DISPLAY_NAMES } from "app/constants/app";
import { getOrderStatusChipStyles } from "../../helpers";

import {
  ShopperOrderBaseCard,
  ShopperOrderConfirmationNoContainer,
  ShopperOrderAmountContainer,
  ShopperOrderAmountSubContainer,
  ShopperOrderProductNoContainer,
  ShopperOrderStatusContainer,
} from "./styles";

export default function ShopperOrderCard({ order }: { order: TOrder }) {
  const productsQty = order.products.reduce((acc, product) => {
    const productQty =
      product.variants && product.variants.length > 0
        ? (product.variants as unknown as any[]).reduce((acc, variant) => {
            return acc + variant.qty;
          }, 0)
        : (product.qty as unknown as number) || 0;

    return acc + productQty;
  }, 0);

  return (
    <ShopperOrderBaseCard>
      <ShopperOrderConfirmationNoContainer>
        <b style={{ color: theme.colorsPalette.white.default }}>
          {order.confirmationNumber}
        </b>

        <Typography as="p" variant="paragraph3">
          {formatDate(order.createdAt, "DD-MM-YY")}
        </Typography>
      </ShopperOrderConfirmationNoContainer>

      <ShopperOrderAmountContainer>
        <ShopperOrderAmountSubContainer>
          <Typography
            as="p"
            variant="paragraph2"
            style={{ color: theme.colorsPalette.white.default }}
          >
            ${formatNumber(order.totalAmount)}
          </Typography>

          {order.coupon && (
            <DiscountTicket
              color={theme.colorsPalette.gray.lighter}
              style={{ marginLeft: 8 }}
            />
          )}
        </ShopperOrderAmountSubContainer>

        <Typography as="p" variant="paragraph3" style={{ marginTop: -4 }}>
          {order.payment.type === "debit"
            ? "Debito"
            : order.payment.type === "credit"
            ? "Credito"
            : ""}
        </Typography>
      </ShopperOrderAmountContainer>

      <ShopperOrderProductNoContainer>
        <p>{productsQty} prod.</p>
      </ShopperOrderProductNoContainer>

      <ShopperOrderStatusContainer>
        <Chip style={getOrderStatusChipStyles(order.status)}>
          {ORDER_STATUS_DISPLAY_NAMES[order.status]}
        </Chip>
      </ShopperOrderStatusContainer>
    </ShopperOrderBaseCard>
  );
}
